export default __webpack_public_path__ + "static/media/Banner_Catsul_menor_500x400_Disabled.9c66babc.jpg";